import { s as surfaceDarkStyles } from '../component/surfaceDark-beb6179f.js';
import { s as surfaceDarkInfoStyles } from '../component/surfaceDarkInfo-c7ac00b4.js';
import { s as surfaceLightStyles } from '../component/surfaceLight-50f0efa5.js';
import { d as deepMerge$1 } from '../../LocalModules/storm-ui-utils/dist/esm/deepMerge-8f442bea-008d6945.js';

const getSurfaceStylesBySurfaceType = (theme, surfaceType) => {
  if (surfaceType === 'dark') return theme.surfaceDark || surfaceDarkStyles;
  if (surfaceType === 'blue') return theme.surfaceDarkInfo || surfaceDarkInfoStyles;
  return theme.surfaceLight || surfaceLightStyles;
};
function surfaceModifier(theme, surfaceType) {
  const surfaceThemeOverrides = getSurfaceStylesBySurfaceType(theme, surfaceType);
  const modifiedTheme = {
    ...theme
  };

  // For any theme targets with overrides, merge the current theme values
  // with any of the overridden values. Making multiple deepMerge calls is
  // arguably better here because of the small number of overridden targets for now.
  Object.entries(surfaceThemeOverrides).forEach(([key, value]) => {
    modifiedTheme[key] = deepMerge$1({}, theme[key], value);
  });
  return modifiedTheme;
}

export { surfaceModifier as s };
//# sourceMappingURL=surface-a750c446.js.map
